import React from 'react';
import PropTypes from 'prop-types';
import { Card, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import AuthorisationButton from '../../components/authorisation-button';

const containerStyle = {
  width: 600,
  margin: '0 auto',
};

const NoLinkedAccounts = ({
  onContinueClick,
}) => (
  <div style={containerStyle}>
    <Card color="red" fluid>
      <Card.Content textAlign="center">
        <Icon name="x" color="orange" size="massive" />
      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>
          NO LINKED ACCOUNTS
        </Card.Header>
      </Card.Content>
      <Card.Content>

        <div style={{ margin: 30 }}>
          <h2>You have no Instagram account<br />linked to your Facebook page!</h2>
          <br />
          <p>Please check that you have <a href="http://help.dyzio.co/en/articles/4044324-how-to-link-your-instagram-account-to-your-facebook-fan-page" target="_blank">linked your Instagram account</a>.</p>
          <br />
          <p>Please check that your Facebook page is a <a href="https://help.dyzio.co/en/articles/4063438-how-to-create-a-facebook-community-page-and-connect-it-to-instagram" target="_blank">community page</a>... not a personal page!</p>
          <br />
          <p>If it is linked then please try <b>unlinking</b> and <b>relinking</b>.</p>

          <hr />
          <p>If you need assistance please use the chat tool in the bottom right corner.</p>
        </div>
      </Card.Content>
      <Card.Content>
        <p>Please click the button below to restart the Authorisation process.</p>
      </Card.Content>
    </Card>
    <Card.Content>


      <AuthorisationButton
        platform={'instagram'}
        disabled={false}
        handleAuthClick={onContinueClick}
      />

    </Card.Content>

  </div>
);

NoLinkedAccounts.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default NoLinkedAccounts;



/** WEBPACK FOOTER **
 ** ./src/containers/token-generation-page/no-linked-accounts.js
 **/